import { inject, Injectable } from '@angular/core';
import { CrmUserService } from '@touch4it/ng-swp/user';
import { Observable, switchMap, tap } from 'rxjs';
import { CrmEndpointListResponse } from '@touch4it/ng-swp/endpoint';
import { CrmDictionary } from '@touch4it/ng-swp/core/types';
import { HttpContext } from '@angular/common/http';

import { ProfilesApiService } from '~/api/profiles/profiles-api.service';
import { SKIP_NAMESPACE_TOKEN } from '~/shared/interceptors/skip-namespace.token';

import { UserModel } from './user.model';

@Injectable({ providedIn: 'root' })
export class UsersApiService extends CrmUserService<UserModel> {
  private profiles = inject(ProfilesApiService);

  deleteUser(id: string) {
    return this.endpoint.request<string>('POST', `${id}/anonymize`);
  }

  list(params?: CrmDictionary): Observable<CrmEndpointListResponse<UserModel>> {
    return this.user$.pipe(
      switchMap((loggedUser) => {
        if (!loggedUser.roles.admin) {
          return this.endpoint.list({ params });
        }

        return this.endpoint.list({
          params,
          context: new HttpContext().set(SKIP_NAMESPACE_TOKEN, true),
        });
      }),
    );
  }

  override logout(options?: object): Observable<string> {
    return super.logout(options).pipe(tap(() => this.profiles.invalidate()));
  }
}
